import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

const IssabelPBX = new Vuex.Store({
    actions: {
        //Get calls from issabel pbx
        getCalls(context, callsDates){
            return new Promise((resolve, reject) => {
                let data = {
                    day: callsDates.day,
                    see_internal: callsDates.internalCalls,
                    see_outbound: callsDates.outboundCalls,
                    see_inbound: callsDates.inboundCalls,
                    startDate: callsDates.startDate,
                    endDate: callsDates.endDate
                }

                axios.post(api.issabelCalls(), data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(response => {
                        reject(response)
                    })
            })
        },
        // UNUSED
        getStats(context, callsDates){
            return new Promise((resolve, reject) => {
                //Data to send
                let data = {
                    day: callsDates.day,
                    see_internal: callsDates.internalCalls,
                    startDate: callsDates.startDate,
                    endDate: callsDates.endDate
                }
                //Make request
                axios.post(api.issabelCallsStats(), data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch((response) => {
                        reject(response)
                    })
            })
        },
        getCallInfo(context, call) {
            return new Promise((resolve, reject) => {

                axios.get(api.issabelCallInfo(call.call_id))
                    .then(response => {
                        resolve(response)
                    })
                    .catch(response => {
                        reject(response);
                    })

            })
        },
        getClient(context, phoneNumber){
            return new Promise((resolve, reject) => {

                axios.get(api.issabelCallClient(phoneNumber))
                    .then(response => {
                        resolve(response)
                    })
                    .catch(response => {
                        reject(response)
                    })

            })
        }

    }
})

export default IssabelPBX